import React, { Component } from 'react'
import ProcessState from '../ProcessState/index'
//import BountyPromo from '../BountyPromo/index'

export default class Finished extends Component {
  render() {
    return (
      <div>
        <ProcessState step={1} />
        {/* <BountyPromo /> */}
      </div>
    )
  }
}
